import Tool, { simpleToolButton } from './Tool';
import redoIconSvg from '../assets/icons/redoIcon.svg';
import { svgToIcon } from '../utils/svg';
import Shortcut from '../utils/Shortcut';

class ToolRedo extends Tool {
  static toolName = 'Redo';
  static shortcut = new Shortcut('Cmd+Shift+Z,Cmd+Y');

  static action({ controller }) {
    controller.undoManager.redo();
  }

  static enabled({ controller }) {
    return controller.hasRedo;
  }

  static buttonComponent() {
    return simpleToolButton(ToolRedo, svgToIcon(redoIconSvg));
  }
}

export default ToolRedo;
